export class Pantallas {
    id: number = 0;
    pantalla: string = "";
    titulo: string = ""
    texto: string = "";
    orden: number = 0;
}